import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { SkeletonLoaderComponent } from '@com-delta-omnichannel/mach';

@Component({
  selector: 'idp-apps-book-widget-desktop-skeleton',
  standalone: true,
  imports: [NgFor, SkeletonLoaderComponent],
  templateUrl: './apps-book-widget-desktop-skeleton.component.html',
  styleUrls: ['./apps-book-widget-desktop-skeleton.component.scss']
})
export class BookWidgetDesktopSkeletonComponent {}
// This component serves as a skeleton loader for the apps booking widget, providing a placeholder UI while data is being loaded.
